// TODO: turn this into strings

// eslint-disable-next-line import/prefer-default-export
export const MultiChipStatesEnum = {
  UNKNOWN: null,
  YES: true,
  NO: false,
};
